export const InteractionType = {
  TextAnswers: "textAnswers",
  DownloadTiles: "downloadTiles",
  Intro: "intro",
  Multiselect: "multiselect",
  TrueOrFalse: "trueOrFalse",
  Dropdown: "dropdown",
  ThumbAnswers: "thumbAnswers",
};
